
import React from 'react';
import DashboardStats from '@/pages/dashboard/DashboardStats';
import RecentArticles from '@/pages/dashboard/RecentArticles';
import RecentTenders from '@/pages/dashboard/RecentTenders';
import RecentJobs from '@/pages/dashboard/RecentJobs';
import RecentEvents from '@/pages/dashboard/RecentEvents';
import ContentPerformance from '@/pages/dashboard/ContentPerformance';
import QuickActions from '@/pages/dashboard/QuickActions';


const Dashboard: React.FC = () => {


  return (
    <div className="h-full flex flex-col">

      <div className="mb-5 flex-shrink-0">
        <DashboardStats />
      </div>

      {/* Content Area - Scrollable */}
      <div className="flex-1 overflow-y-auto min-h-0">
        <div className="space-y-4">

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <RecentArticles />
              <RecentTenders />
              <RecentJobs />
              <RecentEvents />
              <ContentPerformance />
              <QuickActions />
          </div>      
        </div>
      </div>

    </div>
  );
};

export default Dashboard;
